import _ from "lodash";

import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

interface ShortlinkState {}

const initialState: ShortlinkState = {};

const shortlinkSlice = createSlice({
  name: "shortlink",
  initialState,
  reducers: {
    destroy() {
      return initialState;
    }
  }
});

export default shortlinkSlice.reducer;
export const shortlinkActions = shortlinkSlice.actions;
